<script setup lang="ts">
type RatingSize = `medium` | `large` | 'x-large';

const props = withDefaults(
  defineProps<{
    rating: number
    size?: RatingSize
    tag?: string
  }>(), {
    size: `medium`,
    tag: `div`,
  },
);

const icons = computed(() => {
  const floored = Math.floor(props.rating);
  const ceiled = Math.ceil(props.rating);
  const decimals = props.rating * 10 - Math.floor(props.rating) * 10;
  return Array.from({ length: 5 }, (_, index) => {
    if (index === props.rating) return `iad-icon:star`;
    if (index >= floored && index < ceiled) {
      return decimals > 5 ? `iad-icon:star` : `iad-icon:star-half`;
    }
    return (ceiled <= index) ? `iad-icon:star-outlined` : `iad-icon:star`;
  });
});
const iconClasses = computed(() => {
  if (props.size === `x-large`) return `lg:size-10`;
  if (props.size === `large`) return `lg:size-8`;
  return ``;
});
</script>

<template>
  <component
    :is="tag"
    class="flex text-rating"
  >
    <Icon
      v-for="(icon, index) of icons"
      :key="index"
      :name="icon"
      :class="iconClasses"
    />
  </component>
</template>
